export default __webpack_public_path__ + "static/Difi.io-03-c8fc71a3518e86f498ab10673c0a6a58.png";